const formatNumberWithThousands = (
  value: string | number,
  locale = 'es-ES',
  decimals = 2,
): string => {
  if (!value && value !== 0) return '-'
  const normalizedValue =
    typeof value === 'string'
      ? value.replace(/\./g, '').replace(',', '.')
      : value.toString().replace(/\./g, '').replace(',', '.')

  const number = parseFloat(normalizedValue)

  if (isNaN(number)) return '-'
  let formatted = new Intl.NumberFormat(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
    useGrouping: true,
  }).format(number)
  if (locale === 'es-ES' && !formatted.includes(',')) {
    formatted = formatted.replace(/\./g, '#').replace(/,/g, '.').replace(/#/g, '.')
  }

  return formatted
}

export { formatNumberWithThousands }
